import LogoTitle from './LogoTitle';
import PropTypes from 'prop-types';
import React from 'react';
import UserMenu from './UserMenu';
import {Box, Button, Flex} from '@chakra-ui/react';
import {HEADER_HEIGHT} from './Header';

export function SidebarDivider(props) {
  return <Box mx="auto" color="gray.300" boxSize="6" my="6" {...props} />;
}

export function SidebarFooter(props) {
  return <Box mt="auto" pos="sticky" bottom="0" p="4" pt="2" {...props} />;
}

export function SidebarButton({isSelected, ...props}) {
  return (
    <Button
      iconSpacing="3"
      size="lg"
      rounded="lg"
      justifyContent="flex-start"
      variant="ghost"
      px="4"
      bg={isSelected ? 'indigo.50' : undefined}
      colorScheme={isSelected ? 'indigo' : undefined}
      {...props}
    />
  );
}

SidebarButton.propTypes = {
  isSelected: PropTypes.bool
};

export default function Sidebar({children, ...props}) {
  return (
    <Flex
      direction="column"
      as="aside"
      shrink="0"
      borderRightWidth={{md: '1px'}}
      w={{
        base: 'full',
        md: '300px',
        lg: '350px'
      }}
      h="100vh"
      overflow="auto"
      position="sticky"
      top="0"
      {...props}
    >
      <Flex
        align="center"
        px="4"
        h={HEADER_HEIGHT}
        shrink="0"
        position="sticky"
        top="0"
        bg="white"
        zIndex="sticky"
      >
        <LogoTitle mr="auto" />
        <UserMenu />
      </Flex>
      {children}
    </Flex>
  );
}

Sidebar.propTypes = {
  children: PropTypes.node.isRequired
};
